var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.55 60.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.13,54.73A28.31,28.31,0,0,1,5.53,43.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.53,16.57A28.45,28.45,0,0,1,16.13,5.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.51,30.26A28.26,28.26,0,0,0,16.13,5.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.73,16.57A14.16,14.16,0,0,1,44.39,30.26a13.86,13.86,0,0,1-.32,3L54.91,44.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.73,43.94a14.13,14.13,0,0,1,0-27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.53,43.94a28.29,28.29,0,0,1,0-27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.13,54.73a28.29,28.29,0,0,0,29-.45l4.42,4.41,10-10-4.64-4.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSWhite);
export default __webpack_public_path__ + "static/media/logo-s-white.e739f4e1e9793e8cc7c76079fca608c8.svg";
export { ForwardRef as ReactComponent };